module.exports = __webpack_public_path__ + "static/img/loyalty-dummy.75021208.png";